import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import CellularSurfingUseDetailsBlockData from '../../../Models/Content/CellularSurfingUseDetailsBlockData';
import CellularSurfingUseDetails from './CellularSurfingUseDetails'

export default class CellularSurfingUseDetailsBlock extends EpiComponent<CellularSurfingUseDetailsBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <CellularSurfingUseDetails context={this.getContext()} contentData={this.props.data} />;
  }
}
